import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MsgNetLoading from '../components/MsgNetLoading';
import TopHeaderMenu from '../components/TopHeaderMenu';
import RankingSelector from '../components/RankingSelector';
import RankingResultadoList from '../components/RankingResultadoList';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import CONFIG from '../config';
import SharePanel from '../components/SharePanel';

class RankingScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultados: [],
      rankings: [],
      ranking: null,
      competicion: null,
      evento: null,
      showSharePanel: false,
      hasMore: false,
      loadingMore: false
    };
    this.ws = null;
    this.wsReconnectTimer = null;
    this._loadedPage = 1;
  }

  componentDidMount() {
    const competicionId = parseInt(this.props.params.competicionId, 10);
    const rankingId = parseInt(this.props.params.rankingId, 10);
    this.fetchInitData(competicionId, rankingId);
    this.connectWS(competicionId);
  }

  fetchInitData(competicionId, rankingId) {
    fetch(`${CONFIG.API_URL}/api/1.0/live/${competicionId}/init/`)
      .then(r => r.json())
      .then(data => {
        const rankings = data.rankings || [];
        let ranking = null;
        if (rankingId) {
          ranking = rankings.find(r => parseInt(r.id, 10) === rankingId) || rankings[0] || null;
        } else if (rankings.length) {
          ranking = rankings[0];
        }
        this.setState({ competicion: data.competicion, evento: data.evento, rankings, ranking });
        if (ranking) this.fetchRankingResultados(ranking.id);
      })
      .catch(err => console.error('live-init error:', err));
  }

  fetchRankingResultados(rankingId) {
    fetch(`${CONFIG.API_URL}/api/1.0/live/ranking/${rankingId}/?page=1`)
      .then(r => r.json())
      .then(data => {
        if (!this.state.ranking || this.state.ranking.id !== rankingId) return;
        this._loadedPage = 1;
        this.setState({ resultados: data.resultados, hasMore: data.has_more });
      })
      .catch(err => console.error('live-ranking error:', err));
  }

  // Scroll infinito: pide la siguiente pagina y la añade al final del
  // array de resultados. Descarta la respuesta si el ranking cambio
  // mientras el fetch estaba en vuelo.
  loadMoreRankingResultados() {
    const { ranking, loadingMore, hasMore } = this.state;
    if (!ranking || loadingMore || !hasMore) return;
    const rankingId = ranking.id;
    const nextPage = this._loadedPage + 1;
    this.setState({ loadingMore: true });
    fetch(`${CONFIG.API_URL}/api/1.0/live/ranking/${rankingId}/?page=${nextPage}`)
      .then(r => r.json())
      .then(data => {
        if (!this.state.ranking || this.state.ranking.id !== rankingId) return;
        this._loadedPage = nextPage;
        this.setState(prev => ({
          resultados: [...prev.resultados, ...data.resultados],
          hasMore: data.has_more,
          loadingMore: false,
        }));
      })
      .catch(err => {
        console.error('live-ranking loadMore error:', err);
        this.setState({ loadingMore: false });
      });
  }

  // Coalescer solo para las actualizaciones disparadas por el WS: como
  // mucho una peticion en vuelo. Si llega otra actualizacion mientras la
  // anterior sigue en curso, se marca "dirty" para repetir una unica vez
  // mas al terminar, leyendo this.state.ranking en ese momento (por si
  // el usuario cambio de ranking mientras la peticion estaba en curso).
  // fetchInitData y componentDidUpdate siguen llamando a
  // fetchRankingResultados directamente: son eventos puntuales de
  // usuario, no una rafaga repetida, y no necesitan pasar por aqui.
  requestRankingRefresh() {
    if (!this._rankingFetchState) {
      this._rankingFetchState = { dirty: false, inFlight: false };
    }
    const state = this._rankingFetchState;
    state.dirty = true;
    if (state.inFlight) return;
    state.inFlight = true;
    state.dirty = false;
    this._runRankingRefresh();
  }

  _runRankingRefresh() {
    const state = this._rankingFetchState;
    const ranking = this.state.ranking;
    if (!ranking) {
      state.inFlight = false;
      return;
    }
    const requestedRankingId = ranking.id;
    fetch(`${CONFIG.API_URL}/api/1.0/live/ranking/${requestedRankingId}/?page=1`)
      .then(r => r.json())
      .then(data => {
        if (this.state.ranking && this.state.ranking.id === requestedRankingId) {
          this.setState(prev => ({
            resultados: [...data.resultados, ...prev.resultados.slice(data.resultados.length)],
          }));
        }
      })
      .catch(() => {})
      .finally(() => {
        if (state.dirty) {
          state.dirty = false;
          this._runRankingRefresh();
        } else {
          state.inFlight = false;
        }
      });
  }

  connectWS(competicionId) {
    if (this.ws) this.ws.close();
    this.ws = new WebSocket(`${CONFIG.WS_URL}/ws/${competicionId}`);
    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if ((data.tipo === 'update' || data.tipo === 'delta') && this.state.ranking) {
        this.requestRankingRefresh();
      }
    };
    this.ws.onclose = () => {
      this.wsReconnectTimer = setTimeout(() => this.connectWS(competicionId), 3000);
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.ranking !== this.state.ranking && this.state.ranking) {
      this.fetchRankingResultados(this.state.ranking.id);
    }
    if (prevProps.params.rankingId !== this.props.params.rankingId) {
      const rankingId = parseInt(this.props.params.rankingId, 10);
      const ranking = this.state.rankings.find(r => parseInt(r.id, 10) === rankingId) || this.state.rankings[0] || null;
      this.setState({ ranking });
    }
  }

  componentWillUnmount() {
    if (this.wsReconnectTimer) clearTimeout(this.wsReconnectTimer);
    if (this.ws) this.ws.close();
  }

  onClickBack() {
    this.props.navigate(`/${this.state.competicion.evento_id}`);
  }

  toogleSharePanel() {
    this.setState({ showSharePanel: !this.state.showSharePanel });
  }

  render() {
    const { evento, ranking, rankings, resultados, competicion } = this.state;

    if (!competicion) return <MsgNetLoading />;

    return (
      <div>
        <TopHeaderMenu
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
          competicion={competicion}
          evento={evento}
        />
        <CompeticionHeaderMenu competicion={competicion} selected={2} evento={evento} />
        <div className="pt-32">
          <RankingSelector competicion={competicion} rankings={rankings} ranking={ranking} />
          <RankingResultadoList
            ranking={ranking}
            resultados={resultados}
            hasMore={this.state.hasMore}
            loadingMore={this.state.loadingMore}
            onLoadMore={this.loadMoreRankingResultados.bind(this)}
          />
        </div>
        {this.state.showSharePanel && ranking && (
          <SharePanel
            close={this.toogleSharePanel.bind(this)}
            url={`/competicion/${competicion.id}/ranking/${ranking.id}`}
            title={`${ranking.header} en la prueba ${competicion.nombre} (${evento ? evento.nombre : ''})`}
          />
        )}
      </div>
    );
  }
}

function RankingScreen() {
  const navigate = useNavigate();
  const params = useParams();
  return <RankingScreenClass navigate={navigate} params={params} />;
}

export default RankingScreen;
